import { useEffect, useState } from "react";
import { IAxiosGetResponse, IInstitutionDto } from "../../interfaces/IUtilities";
import { getById } from "../_request";
import { useTranslation } from "react-i18next";
import { useToast } from "../../modules/layout/components/ToastContext";
import { useNavigate, useParams } from "react-router-dom";
import Loader from '../../modules/layout/components/Loader';
import BackButton from "../../modules/layout/components/BackButton";
import AppBreadcrumb from "../../modules/layout/components/AppBreadcrumb";

const InstitutionDetails: React.FC = () => {
    
    const { t } = useTranslation();
    const { showToast } = useToast();
    const { id } = useParams();
    const [institution, setInstitution] = useState({} as IInstitutionDto);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const fetchData = async () => {
            try {
                let result = await getById("/api/institutions/", id!);
                let respStatus = result?.status || result?.response.status;
    
                if (respStatus === 200) {
                    setInstitution(result.data as IInstitutionDto);
                    setLoading(false);
                }
                else if (respStatus === 403) {
                    navigate("/error/403");
                }
                else if (respStatus === 401) {
                    navigate("/auth/login");
                }
                else if (respStatus === 500) {
                    navigate("/error/500");
                }
                else {
                    throw new Error(t('StatusCode', {code: String(respStatus)}));
                }
            } catch (error) {
                setLoading(false);
                console.log(t('ConnectionError', {error: String(error)}));
                showToast(t('ConnectionError', {error: String(error)}), 'error');
                navigate("/services/list");
            }
        }
        fetchData();
    
      }, [id]);

    return (
    <div className="container mt-4 gg-container-card">
      <AppBreadcrumb 
        items={[
            { title: t('Home'), href: "/" },
            { title: t('Institutions'), href: "/institutions/list" },
            { title: t('InstitutionDetailsWithName', { institutionName: institution ? institution.name : ""}) } // Active page (no href)
        ]} />

      <h3>{t('InstitutionDetails')}</h3>
      
      {loading && (<Loader />)}
    
      <div className="card my-3">
        <div className="card-header">
          <h4>{institution.name}</h4>
        </div>
          <div className="card-body">
              <p><strong>{t('Id')}:</strong> {institution.id}</p>
          </div>
          <div className="card-footer bg-transparent">
              <BackButton goTo={"/institutions/list"}/>

              <button className="btn gg-btn ms-3" onClick={() => navigate(`/institutions/edit/${institution.id}`)}>
                  {t('Edit')}
              </button>
          </div>
      </div>

    </div>
    )
}
export default InstitutionDetails
